var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('treeselect',{attrs:{"multiple":true,"value":_vm.value,"options":_vm.options,"placeholder":_vm.placeholder,"load-options":_vm.loadChildren,"default-expand-level":1,"value-consists-of":"LEAF_PRIORITY"},on:{"input":_vm.onTreeselectInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }